import { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { IconLoader2 } from '@tabler/icons-react';

import AppLayout from '@/shared/layout/AppLayout';
import ApplicationPortal from '@/portals/application/routes';
import SiteComplianceRoutes from '@/portals/siteCompliance/routes';
import NewsletterRoutes from '@/features/newsletter/routes';
import SettingsRoutes from '@/features/settings/routes';
import EvaluationRoutes from '@/features/evaluationResults/routes';
import { SITE_COMPLIANCE_PORTAL_ENABLED } from '@/config/env';

const SuspenseFallback = () => (
  <div className="flex h-full w-full items-center justify-center">
    <IconLoader2 className="animate-spin text-[#005b92]" size={32} />
  </div>
);

const OnboardRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/applications/onboard${search}`} replace />;
};

const AppRouter = () => {
  if (SITE_COMPLIANCE_PORTAL_ENABLED) {
    return (
      <Routes>
        <Route element={<AppLayout />}>
          <Route
            path="/*"
            element={
              <Suspense fallback={<SuspenseFallback />}>
                <SiteComplianceRoutes />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="" element={<Navigate to="applications" replace />} />
        <Route
          path="applications/*"
          element={
            <Suspense fallback={<SuspenseFallback />}>
              <ApplicationPortal />
            </Suspense>
          }
        />
        <Route
          path="newsletter/*"
          element={
            <Suspense fallback={<SuspenseFallback />}>
              <NewsletterRoutes />
            </Suspense>
          }
        />
        <Route path="onboard" element={<OnboardRedirect />} />
        <Route
          path="settings/*"
          element={
            <Suspense fallback={<SuspenseFallback />}>
              <SettingsRoutes />
            </Suspense>
          }
        />
        <Route
          path="evaluations/*"
          element={
            <Suspense fallback={<SuspenseFallback />}>
              <EvaluationRoutes />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRouter;
